import { render } from "./customerWorkshopSelection.vue?vue&type=template&id=204d2c2c&scoped=true"
import script from "./customerWorkshopSelection.vue?vue&type=script&lang=js"
export * from "./customerWorkshopSelection.vue?vue&type=script&lang=js"

import "./customerWorkshopSelection.vue?vue&type=style&index=0&id=204d2c2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204d2c2c"]])

export default __exports__